<template>
	<section class="Unsupported">
		Unsupported message
	</section>
</template>

<script>
	export default {
		
	};
</script>

<style lang="scss" scoped>
	.Unsupported {
		padding: 1rem 1.6rem;
		color: #aaa;
	}
</style>